(function () {
  const SELECTORS = {
    root: '.section--freeman-wrap',
    flame: '.js-flame',
    hero: '.section--freeman-hero',
    heroBg: '.freeman-hero__bg',
    heroCenter: '.freeman-hero__center',
    heroEye: '.freeman-hero__eye',
    heroImg: '.freeman-hero__img',
    heroImgAlt: '.freeman-hero__img-2',
    heroShadow: '.freeman-hero__shadow',
    heroStage: '.freeman-hero',
    heroSpiral: '.freeman-hero__spiral',
    advantagesSection: '.section--freeman-advantages',
    advantages: '.freeman-advantages',
    advantageImages: '.freeman-advantages__images',
    advantageDots: '.freeman-advantages__dots',
    advantageItem: '.freeman-advantages__item',
    advantageImage: '.freeman-advantages__img',
    illustration: '.section--freeman-illustration',
    illustrationCircle: '.freeman-illustration__circle',
    illustrationLadder: '.freeman-illustration__ladder',
    illustrationThink: '.freeman-illustration__think',
    illustrationInfoBg: '.freeman-illustration__info-bg',
    illustrationInfoTitle: '.freeman-illustration__info-title'
  };

  const REVEAL_SELECTOR = [
    '.freeman-info__block',
    '.freeman-texts',
    '.freeman-crafted__block'
  ].join(', ');

  const FLAME_SHAPE_URLS = [
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim1.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim2.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim3.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim4.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim5.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim6.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim7.svg?v=1782293061',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/anim8.svg?v=1782293061'
  ];

  const HERO_EYE_SHAPE_URLS = [
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/freeman-eye-1.svg?v=1782298460',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/freeman-eye-2.svg?v=1782298461',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/freeman-eye-3.svg?v=1782298461',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/freeman-eye-4.svg?v=1782298462',
    'https://cdn.shopify.com/s/files/1/0669/6475/0628/files/freeman-eye-5.svg?v=1782298461'
  ];

  const HERO_PIN_HOLD_SCROLL_RATIO = 0.5;
  const HERO_PIN_HOLD_SCROLL_MIN = 360;
  const HERO_PIN_HOLD_SCROLL_MAX = 720;
  const HERO_ALT_START_SCALE = 0.25;
  const HERO_ALT_ZOOM_DURATION = 0.2;
  const ILLUSTRATION_SCROLL_RATIO = 1.2;
  const ILLUSTRATION_SCROLL_MIN = 900;
  const ILLUSTRATION_SCROLL_MAX = 1800;
  const ILLUSTRATION_CIRCLE_HEIGHT_RATIO = 1.45;
  const ILLUSTRATION_CIRCLE_MIN_SCALE = 0.52;
  const ILLUSTRATION_CIRCLE_MAX_SCALE = 0.85;
  const ADVANTAGES_SCROLL_PER_ITEM_RATIO = 0.38;
  const ADVANTAGES_SCROLL_MIN = 1000;
  const ADVANTAGES_SCROLL_MAX = 2800;
  const ADVANTAGES_FIRST_SWITCH_PROGRESS = 0.08;
  const ADVANTAGES_PROGRESS_HYSTERESIS = 0.025;
  const ADVANTAGES_CENTER_START_MIN_SPACE = 160;
  const HERO_REFRESH_PRIORITY = 30;
  const ADVANTAGES_REFRESH_PRIORITY = 20;
  const ILLUSTRATION_REFRESH_PRIORITY = 10;
  let deferredRefreshTimer;
  let deferredRefreshPending = false;

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function toArray(items) {
    return Array.prototype.slice.call(items);
  }

  function mobile() {
    return window.isMobile || window.innerWidth <= 768;
  }

  function tablet() {
    return window.isTablet || window.matchMedia('(max-width: 1024px)').matches;
  }

  function heroPinEnabled() {
    return !tablet();
  }

  function advantagesStaticMode() {
    return window.matchMedia('(max-width: 1024px)').matches;
  }

  function viewportHeight() {
    return window.innerHeight || document.documentElement.clientHeight || 0;
  }

  function viewportWidth() {
    return window.innerWidth || document.documentElement.clientWidth || 0;
  }

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function heroPinHoldScroll() {
    return Math.round(clamp(
      viewportHeight() * HERO_PIN_HOLD_SCROLL_RATIO,
      HERO_PIN_HOLD_SCROLL_MIN,
      HERO_PIN_HOLD_SCROLL_MAX
    ));
  }

  function illustrationScrollDistance() {
    return Math.round(clamp(
      viewportHeight() * ILLUSTRATION_SCROLL_RATIO,
      ILLUSTRATION_SCROLL_MIN,
      ILLUSTRATION_SCROLL_MAX
    ));
  }

  function advantagesScrollDistance(itemsCount) {
    return Math.round(clamp(
      viewportHeight() * Math.max(itemsCount, 2) * ADVANTAGES_SCROLL_PER_ITEM_RATIO,
      ADVANTAGES_SCROLL_MIN,
      ADVANTAGES_SCROLL_MAX
    ));
  }

  function advantageIndexFromProgress(progress, itemsCount, currentIndex) {
    if (itemsCount <= 1) {
      return 0;
    }

    if (progress < ADVANTAGES_FIRST_SWITCH_PROGRESS) {
      return 0;
    }

    let current = Math.max(currentIndex, 0);

    for (let index = 1; index < itemsCount; index++) {
      let threshold = ADVANTAGES_FIRST_SWITCH_PROGRESS +
        ((index - 1) / (itemsCount - 1)) * (1 - ADVANTAGES_FIRST_SWITCH_PROGRESS);

      if (progress < threshold - ADVANTAGES_PROGRESS_HYSTERESIS) {
        return Math.max(0, index - 1);
      }

      if (progress < threshold + ADVANTAGES_PROGRESS_HYSTERESIS) {
        return current;
      }
    }

    return itemsCount - 1;
  }

  function advantagesPinStart(section) {
    let pinArea = section.closest(SELECTORS.advantagesSection) || section;
    let freeSpace = viewportHeight() - pinArea.offsetHeight;

    if (freeSpace <= ADVANTAGES_CENTER_START_MIN_SPACE) {
      return 'top top';
    }

    return 'center center';
  }

  function refreshScrollTrigger() {
    window.ScrollTrigger.sort();
    window.ScrollTrigger.refresh(true);
  }

  function scrollTriggerIsScrolling() {
    return typeof window.ScrollTrigger.isScrolling === 'function' && window.ScrollTrigger.isScrolling();
  }

  function runDeferredRefresh() {
    if (scrollTriggerIsScrolling()) {
      deferredRefreshTimer = window.setTimeout(runDeferredRefresh, 200);
      return;
    }

    if (deferredRefreshPending) {
      window.ScrollTrigger.removeEventListener('scrollEnd', runDeferredRefresh);
      deferredRefreshPending = false;
    }

    window.clearTimeout(deferredRefreshTimer);
    refreshScrollTriggerAfterResize();
  }

  function refreshScrollTriggerWhenIdle() {
    window.clearTimeout(deferredRefreshTimer);

    if (!scrollTriggerIsScrolling()) {
      runDeferredRefresh();
      return;
    }

    if (!deferredRefreshPending) {
      deferredRefreshPending = true;
      window.ScrollTrigger.addEventListener('scrollEnd', runDeferredRefresh);
    }

    deferredRefreshTimer = window.setTimeout(runDeferredRefresh, 300);
  }

  function refreshScrollTriggerAfterResize() {
    if (typeof window.setViewportVars === 'function') {
      window.setViewportVars(false);
    }

    refreshScrollTrigger();

    requestAnimationFrame(function () {
      if (typeof window.setViewportVars === 'function') {
        window.setViewportVars(false);
      }

      refreshScrollTrigger();
    });

    setTimeout(function () {
      if (typeof window.setViewportVars === 'function') {
        window.setViewportVars(false);
      }

      refreshScrollTrigger();
    }, 300);
  }

  function refreshAfterLayout(root) {
    let images = toArray(root.querySelectorAll('img'));
    let imageReady = images.map(function (image) {
      if (image.complete) {
        return Promise.resolve();
      }

      if (image.decode) {
        return image.decode().catch(function () {});
      }

      return new Promise(function (resolve) {
        image.addEventListener('load', resolve, { once: true });
        image.addEventListener('error', resolve, { once: true });
      });
    });

    Promise.all(imageReady).then(refreshScrollTrigger);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshScrollTrigger);
    }

    window.addEventListener('load', refreshScrollTrigger, { once: true });
    requestAnimationFrame(function () {
      requestAnimationFrame(refreshScrollTrigger);
    });
    setTimeout(refreshScrollTrigger, 300);
    setTimeout(refreshScrollTrigger, 900);
  }

  function bindResizeRefresh() {
    let resizeTimer;
    let resizeWidth = viewportWidth();
    let resizeNeedsFullRefresh = false;

    window.addEventListener('resize', function () {
      let nextWidth = viewportWidth();
      let widthChanged = Math.abs(nextWidth - resizeWidth) > 1;

      if (widthChanged) {
        resizeWidth = nextWidth;
        resizeNeedsFullRefresh = true;
      }

      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (resizeNeedsFullRefresh) {
          resizeNeedsFullRefresh = false;
          refreshScrollTriggerAfterResize();
          return;
        }

        refreshScrollTriggerWhenIdle();
      }, 180);
    });
  }

  function revealOnEnter(root, selector) {
    window.gsap.utils.toArray(root.querySelectorAll(selector)).forEach(function (item) {
      window.gsap.fromTo(item, {
        y: 80,
        opacity: 0
      }, {
        y: 0,
        opacity: 1,
        duration: 0.8,
        scrollTrigger: {
          trigger: item,
          start: 'top 90%',
          once: true
        }
      });
    });
  }

  function initPage(root) {
    window.gsap.registerPlugin(window.ScrollTrigger);
    window.ScrollTrigger.config({ ignoreMobileResize: true });

    initAdvantages(root);
    initFlames();
    initHero(root);
    initAdvantagesScroll(root);
    initFreemanIllustration(root);
    revealOnEnter(root, REVEAL_SELECTOR);
    refreshAfterLayout(root);
    bindResizeRefresh();
  }

  function initHero(root) {
    let hero = root.querySelector(SELECTORS.hero);

    if (!hero) {
      return;
    }

    let heroBg = hero.querySelector(SELECTORS.heroBg);
    let heroEye = hero.querySelector(SELECTORS.heroEye);
    let heroImg = hero.querySelector(SELECTORS.heroImg);
    let heroImgAlt = hero.querySelector(SELECTORS.heroImgAlt);
    let heroShadow = hero.querySelector(SELECTORS.heroShadow);
    let heroStage = hero.querySelector(SELECTORS.heroStage);
    let heroSpirals = hero.querySelectorAll(SELECTORS.heroSpiral);

    if (!heroBg || !heroImg || !heroShadow) {
      return;
    }

    let centeredHeroElements = [heroBg, heroImg, heroShadow];

    if (heroEye) {
      centeredHeroElements.push(heroEye);
    }

    if (heroImgAlt) {
      centeredHeroElements.push(heroImgAlt);
    }

    window.gsap.set(centeredHeroElements, {
      xPercent: -50,
      x: 0
    });

    initHeroBackground(hero, heroBg);
    initHeroFloat(heroImg, heroShadow, heroEye);
    initHeroSpirals(heroSpirals);
    initHeroCenter(hero);
    initHeroEyeMorph(hero, heroEye);
    initHeroPinAfterEyeMorph(hero, heroStage, heroEye, heroImg, heroShadow, heroImgAlt);
  }

  function initHeroBackground(hero, heroBg) {
    window.gsap.fromTo(heroBg, {
      y: 300
    }, {
      y: -250,
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top bottom',
        end: '+=3000',
        scrub: true
      }
    });
  }

  function initHeroFloat(heroImg, heroShadow, heroEye) {
    let floatingElements = heroEye ? [heroImg, heroEye] : heroImg;

    window.gsap.timeline({
      repeat: -1,
      yoyo: true,
      defaults: {
        duration: 1.8,
        ease: 'sine.inOut'
      }
    })
      .fromTo(floatingElements, {
        y: 80
      }, {
        y: 30
      }, 0)
      .to(heroShadow, {
        scaleX: 0.82,
        scaleY: 0.78,
      }, 0);
  }

  function initHeroSpirals(heroSpirals) {
    toArray(heroSpirals).forEach(function (spiral, index) {
      window.gsap.to(spiral, {
        rotate: index % 2 === 0 ? '+=360' : '-=360',
        duration: index % 2 === 0 ? 4 : 10,
        ease: 'none',
        repeat: -1,
        transformOrigin: '50% 50%'
      });
    });
  }

  function initHeroCenter(hero) {
    let heroCenter = hero.querySelector(SELECTORS.heroCenter);

    if (!heroCenter) {
      return;
    }

    window.gsap.fromTo(heroCenter, {
      y: function () {
        return tablet() ? 40 : 90;
      }
    }, {
      y: function () {
        return tablet() ? -40 : -120;
      },
      ease: 'none',
      scrollTrigger: {
        trigger: hero,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
        invalidateOnRefresh: true
      }
    });
  }

  function initHeroEyeMorph(hero, heroEye) {
    if (!heroEye) {
      return;
    }

    Promise.all(HERO_EYE_SHAPE_URLS.map(loadHeroEyeShape))
      .then(function (shapes) {
        initHeroEyeMorphTimeline(hero, heroEye, shapes);
      })
      .catch(console.error);
  }

  function loadHeroEyeShape(url) {
    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'image/svg+xml');
        let paths = toArray(doc.querySelectorAll('path')).map(function (path) {
          return path.getAttribute('d');
        });

        if (paths.length !== 2) {
          throw new Error(`Expected 2 paths in ${url}`);
        }

        return {
          paths: paths,
          doc: doc
        };
      });
  }

  function initHeroEyeMorphTimeline(hero, heroEye, shapes) {
    if (!shapes.length) {
      return;
    }

    heroEye.innerHTML = shapes[0].doc.documentElement.outerHTML;

    let svg = heroEye.querySelector('svg');
    if (svg) {
      svg.removeAttribute('width');
      svg.removeAttribute('height');
    }

    let pathsInDOM = toArray(heroEye.querySelectorAll('path'));

    if (!pathsInDOM.length) {
      return;
    }

    let timeline = window.gsap.timeline({
      scrollTrigger: {
        trigger: heroEye,
        start: 'top 80%',
        end: 'center center',
        scrub: true,
        invalidateOnRefresh: true
      }
    });

    for (let index = 1; index < shapes.length; index++) {
      let shape = shapes[index];
      let label = `eye${index}`;

      if (shape.paths.length !== pathsInDOM.length) {
        continue;
      }

      timeline.add(label);

      shape.paths.forEach(function (pathData, pathIndex) {
        timeline.to(pathsInDOM[pathIndex], {
          duration: 1,
          ease: 'none',
          morphSVG: {
            shape: pathData,
            precision: 0.2
          }
        }, label);
      });
    }

    refreshScrollTrigger();
  }

  function initHeroPinAfterEyeMorph(hero, heroStage, heroEye, heroImg, heroShadow, heroImgAlt) {
    if (!heroStage || !heroEye || !heroImg || !heroShadow || !heroImgAlt) {
      return;
    }

    let heroAltZoomTween;
    let heroAltTrigger;
    let resizeTimer;
    let currentHeroPinEnabled;

    function resetHeroAlt() {
      if (heroAltZoomTween) {
        heroAltZoomTween.kill();
      }

      window.gsap.set(heroImgAlt, {
        autoAlpha: 0,
        scale: HERO_ALT_START_SCALE,
        y: 0
      });
      window.gsap.set([heroImg, heroEye, heroShadow], { autoAlpha: 1 });
    }

    function destroyHeroAltTrigger() {
      if (!heroAltTrigger) {
        return;
      }

      heroAltTrigger.kill(true);
      heroAltTrigger = null;
    }

    function heroAltCenterY(scale, shouldPin) {
      if (!shouldPin) {
        return 0;
      }

      window.gsap.set(heroImgAlt, {
        y: 0,
        scale: scale
      });

      let rect = heroImgAlt.getBoundingClientRect();

      return Math.round((viewportHeight() / 2) - (rect.top + rect.height / 2));
    }

    function showPinnedHeroAlt(animate, shouldPin) {
      if (heroAltZoomTween) {
        heroAltZoomTween.kill();
      }

      let startScale = animate ? HERO_ALT_START_SCALE : 1.2;
      let centerY = heroAltCenterY(startScale, shouldPin);

      window.gsap.set([heroImg, heroEye, heroShadow], { autoAlpha: 0 });

      if (!animate) {
        window.gsap.set(heroImgAlt, {
          autoAlpha: 1,
          scale: 1.2,
          y: centerY
        });
        return;
      }

      heroAltZoomTween = window.gsap.fromTo(heroImgAlt, {
        autoAlpha: 1,
        scale: HERO_ALT_START_SCALE,
        y: centerY
      }, {
        scale: 1.2,
        duration: HERO_ALT_ZOOM_DURATION,
        ease: 'power2.out',
        overwrite: 'auto'
      });
    }

    function hidePinnedHeroAlt() {
      if (heroAltZoomTween) {
        heroAltZoomTween.kill();
      }

      window.gsap.set([heroImg, heroEye, heroShadow], { autoAlpha: 0 });
      window.gsap.set(heroImgAlt, { autoAlpha: 1 });

      heroAltZoomTween = window.gsap.to(heroImgAlt, {
        scale: HERO_ALT_START_SCALE,
        duration: HERO_ALT_ZOOM_DURATION,
        ease: 'power2.in',
        overwrite: 'auto',
        onComplete: function () {
          window.gsap.set(heroImgAlt, {
            autoAlpha: 0,
            scale: HERO_ALT_START_SCALE,
            y: 0
          });
          window.gsap.set([heroImg, heroEye, heroShadow], { autoAlpha: 1 });
        }
      });
    }

    window.gsap.set(heroImgAlt, {
      autoAlpha: 0,
      scale: HERO_ALT_START_SCALE,
      transformOrigin: '50% 50%',
      y: 0
    });

    function createHeroAltTrigger() {
      let shouldPin = heroPinEnabled();

      destroyHeroAltTrigger();
      currentHeroPinEnabled = shouldPin;

      heroAltTrigger = window.ScrollTrigger.create({
        trigger: heroEye,
        start: 'center center',
        end: function () {
          return `+=${heroPinHoldScroll()}`;
        },
        pin: shouldPin ? heroStage : false,
        pinSpacing: shouldPin,
        anticipatePin: shouldPin ? 1 : 0,
        refreshPriority: HERO_REFRESH_PRIORITY,
        invalidateOnRefresh: true,
        onEnter: function () {
          showPinnedHeroAlt(true, shouldPin);
        },
        onEnterBack: function () {
          showPinnedHeroAlt(false, shouldPin);
        },
        onLeave: function () {
          if (!shouldPin) {
            hidePinnedHeroAlt();
          }
        },
        onRefresh: function (self) {
          if (!self.isActive) {
            resetHeroAlt();
          }
        },
        onLeaveBack: function () {
          hidePinnedHeroAlt();
        }
      });
    }

    createHeroAltTrigger();

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        if (heroPinEnabled() === currentHeroPinEnabled) {
          return;
        }

        destroyHeroAltTrigger();
        resetHeroAlt();
        refreshScrollTrigger();
        createHeroAltTrigger();
        refreshScrollTriggerAfterResize();
      }, 180);
    });
  }

  function initAdvantages(root) {
    root.querySelectorAll(SELECTORS.advantages).forEach(function (section) {
      let items = toArray(section.querySelectorAll(SELECTORS.advantageItem));

      if (!items.length) {
        return;
      }

      setActiveAdvantage(items, 0);
    });
  }

  function initAdvantagesScroll(root) {
    root.querySelectorAll(SELECTORS.advantages).forEach(function (section) {
      let items = toArray(section.querySelectorAll(SELECTORS.advantageItem));

      if (!items.length) {
        return;
      }

      initAdvantagesInteraction(section, items);
    });
  }

  function initAdvantagesInteraction(section, items) {
    let mode;
    let scrollTrigger;
    let imageSwiper;
    let resizeTimer;

    function destroyScrollTrigger() {
      if (!scrollTrigger) {
        return;
      }

      scrollTrigger.kill();
      scrollTrigger = null;
    }

    function destroyImageSwiper() {
      if (!imageSwiper) {
        return;
      }

      imageSwiper.destroy(true, true);
      imageSwiper = null;
    }

    function updateMode() {
      let nextMode = advantagesStaticMode() ? 'static' : 'scroll';

      if (mode === nextMode) {
        if (imageSwiper) {
          imageSwiper.update();
        }

        return;
      }

      destroyScrollTrigger();
      mode = nextMode;

      if (mode === 'scroll') {
        destroyImageSwiper();
        scrollTrigger = createAdvantagesScrollTrigger(section, items);
      } else {
        imageSwiper = initAdvantagesImageSwiper(section, items);
        setActiveAdvantage(items, 0);
      }

      refreshScrollTrigger();
    }

    updateMode();

    window.addEventListener('resize', function () {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(updateMode, 180);
    });
  }

  function initAdvantagesImageSwiper(section, items) {
    let slider = section.querySelector(SELECTORS.advantageImages);
    let dots = section.querySelector(SELECTORS.advantageDots);

    if (!slider || !window.Swiper) {
      return null;
    }

    return new window.Swiper(slider, {
      slidesPerView: 1,
      speed: 450,
      watchOverflow: true,
      pagination: {
        el: dots,
        clickable: true,
        bulletClass: 'product-gallery__line',
        bulletActiveClass: 'active',
        renderBullet: function (index, className) {
          return `<button type="button" class="${className}" aria-label="Show image ${index + 1}"></button>`;
        }
      },
      on: {
        slideChange: function (swiper) {
          setActiveAdvantage(items, swiper.realIndex);
        }
      }
    });
  }

  function createAdvantagesScrollTrigger(section, items) {
    let activeIndex = Math.max(items.findIndex(function (item) {
      return item.classList.contains('active');
    }), 0);

    return window.ScrollTrigger.create({
      trigger: section,
      start: function () {
        return advantagesPinStart(section);
      },
      end: function () {
        return `+=${advantagesScrollDistance(items.length)}`;
      },
      pin: section,
      pinSpacing: true,
      anticipatePin: 1,
      refreshPriority: ADVANTAGES_REFRESH_PRIORITY,
      scrub: true,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        let index = advantageIndexFromProgress(self.progress, items.length, activeIndex);

        if (index === activeIndex) {
          return;
        }

        activeIndex = index;
        setActiveAdvantage(items, activeIndex);
      },
      onEnter: function (self) {
        activeIndex = advantageIndexFromProgress(self.progress, items.length, activeIndex);
        setActiveAdvantage(items, activeIndex);
      },
      onEnterBack: function (self) {
        activeIndex = advantageIndexFromProgress(self.progress, items.length, activeIndex);
        setActiveAdvantage(items, activeIndex);
      },
      onLeaveBack: function () {
        activeIndex = 0;
        setActiveAdvantage(items, activeIndex);
      }
    });
  }

  function setActiveAdvantage(items, index) {
    let nextIndex = index;

    if (nextIndex < 0) {
      nextIndex = 0;
    }

    nextIndex = Math.min(items.length - 1, nextIndex);

    let section = items[0].closest(SELECTORS.advantages);
    if (section && section.dataset.activeIndex === String(nextIndex)) {
      return;
    }

    items.forEach(function (item, itemIndex) {
      item.classList.toggle('active', itemIndex === nextIndex);
    });

    setActiveAdvantageImage(section, nextIndex);

    if (section) {
      section.dataset.activeIndex = String(nextIndex);
    }
  }

  function setActiveAdvantageImage(section, index) {
    if (!section) {
      return;
    }

    let images = toArray(section.querySelectorAll(SELECTORS.advantageImage));

    if (!images.length) {
      return;
    }

    let activeImage = images.find(function (image) {
      return image.dataset.advantageIndex === String(index);
    }) || images[Math.min(index, images.length - 1)] || images[0];

    images.forEach(function (image) {
      image.classList.toggle('active', image === activeImage);
    });
  }

  function elementOffsetTopWithin(parent, element) {
    let offset = 0;
    let node = element;

    while (node && node !== parent) {
      offset += node.offsetTop || 0;
      node = node.offsetParent;
    }

    return offset;
  }

  function illustrationCircleIntroY() {
    return mobile() ? '-8%' : '-15%';
  }

  function illustrationCircleTargetY(illustration, circle) {
    if (!circle || mobile()) {
      return illustrationCircleIntroY();
    }

    let circleCenter = elementOffsetTopWithin(illustration, circle) + circle.offsetHeight / 2;

    return Math.round(viewportHeight() / 2 - circleCenter);
  }

  function illustrationCircleTargetScale(circle) {
    if (!circle || mobile()) {
      return ILLUSTRATION_CIRCLE_MAX_SCALE;
    }

    let scaleByHeight = viewportHeight() * ILLUSTRATION_CIRCLE_HEIGHT_RATIO / circle.offsetHeight;

    return clamp(scaleByHeight, ILLUSTRATION_CIRCLE_MIN_SCALE, ILLUSTRATION_CIRCLE_MAX_SCALE);
  }

  function illustrationLadderIntroScale() {
    return mobile() ? 0.8 : 1.4;
  }

  function illustrationLadderTargetY() {
    return mobile() ? '-40%' : '-60%';
  }

  function illustrationLadderTargetScale() {
    return mobile() ? 0.3 : 0.4;
  }

  function initFreemanIllustration(root) {
    let illustration = root.querySelector(SELECTORS.illustration);

    if (!illustration) {
      return;
    }

    let illustrationCircle = illustration.querySelector(SELECTORS.illustrationCircle);

    const illustrationTimeline = window.gsap.timeline({
      scrollTrigger: {
        trigger: illustration,
        start: 'top top',
        end: function () {
          return `+=${illustrationScrollDistance()}`;
        },
        scrub: 1,
        pin: true,
        pinSpacing: tablet(),
        refreshPriority: ILLUSTRATION_REFRESH_PRIORITY,
        ease: 'none',
        invalidateOnRefresh: true
      }
    });

    illustrationTimeline.addLabel('frame1', 0);
    illustrationTimeline.addLabel('frame2', 0.1);
    illustrationTimeline.addLabel('frame3', 'frame2+=0.6');
    illustrationTimeline.addLabel('frame4', 'frame2+=0.6');
    illustrationTimeline.addLabel('frame5', 'frame4+=0.5');
    illustrationTimeline.addLabel('frame6', 'frame5+=0.1');

    illustrationTimeline.fromTo(SELECTORS.illustrationCircle, {
      opacity: 0
    }, {
      opacity: 1,
      duration: 0.1
    }, 'frame1');

    illustrationTimeline.fromTo(SELECTORS.illustrationCircle, {
      scale: 0.005
    }, {
      scale: 0.25,
      y: illustrationCircleIntroY,
      duration: 0.7
    }, 'frame1');

    illustrationTimeline.fromTo(SELECTORS.illustrationLadder, {
      y: '100%',
      scale: illustrationLadderIntroScale,
      opacity: 1
    }, {
      y: '-20%',
      scale: illustrationLadderIntroScale,
      opacity: 1,
      duration: 0.6
    }, 'frame2');

    illustrationTimeline.fromTo(SELECTORS.illustrationCircle, {
      scale: 0.25,
      y: illustrationCircleIntroY
    }, {
      y: function () {
        return illustrationCircleTargetY(illustration, illustrationCircle);
      },
      scale: function () {
        return illustrationCircleTargetScale(illustrationCircle);
      },
      duration: 0.6
    }, 'frame3');

    illustrationTimeline.fromTo(SELECTORS.illustrationLadder, {
      y: '-20%',
      scale: illustrationLadderIntroScale,
      opacity: 1
    }, {
      y: illustrationLadderTargetY,
      scale: illustrationLadderTargetScale,
      opacity: 1,
      duration: 0.6
    }, 'frame4');

    illustrationTimeline.fromTo(SELECTORS.illustrationThink, {
      opacity: 1
    }, {
      opacity: 1,
      duration: 0.1
    }, 'frame5');

    illustrationTimeline.fromTo(`${SELECTORS.illustrationThink} svg`, {
      xPercent: -50,
      yPercent: -50,
      scale: 0,
      rotate: '15deg'
    }, {
      xPercent: -50,
      yPercent: -50,
      scale: 1,
      opacity: 1,
      rotate: '0deg',
      duration: 0.2
    }, 'frame6');

    illustrationTimeline.fromTo(SELECTORS.illustrationInfoBg, {
      opacity: 0
    }, {
      opacity: 1,
      duration: 1
    }, 'frame6');

    illustrationTimeline.fromTo(SELECTORS.illustrationInfoTitle, {
      y: '100vh'
    }, {
      y: '0',
      duration: 0.4
    }, 'frame6');
  }

  function initFlames() {
    const morphSvgs = document.querySelectorAll(SELECTORS.flame);

    if (!morphSvgs.length) {
      return;
    }

    const svgPaths = [];

    Promise.all(FLAME_SHAPE_URLS.map(loadFlameShape))
      .then(function (shapes) {
        shapes.forEach(function (shape) {
          svgPaths.push(shape.paths);
        });

        shapes = shapes.concat(shapes.reverse());
        initFlameMorphing(morphSvgs, svgPaths, shapes[0].doc);
      })
      .catch(console.error);
  }

  function loadFlameShape(url) {
    return fetch(url)
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'image/svg+xml');
        let paths = toArray(doc.querySelectorAll('path')).map(function (path) {
          return path.getAttribute('d');
        });

        if (paths.length !== 5) {
          throw new Error(`Expected 5 paths in ${url}`);
        }

        return {
          paths: paths,
          doc: doc
        };
      });
  }

  function initFlameMorphing(morphSvgs, svgPaths, doc) {
    toArray(morphSvgs).forEach(function (morphSvg) {
      morphSvg.innerHTML = doc.documentElement.innerHTML;

      let pathsInDOM = morphSvg.querySelectorAll('path');
      let timeline = window.gsap.timeline({ repeat: -1 });

      for (let index = 1; index < svgPaths.length; index++) {
        let shape = svgPaths[index];

        if (shape.length !== pathsInDOM.length) {
          continue;
        }

        let label = `step${index}`;
        timeline.add(label);

        shape.forEach(function (pathData, pathIndex) {
          timeline.to(pathsInDOM[pathIndex], {
            duration: 0.2,
            ease: 'none',
            morphSVG: {
              shape: pathData,
              precision: 0.2
            }
          }, label);
        });
      }
    });

    refreshScrollTrigger();
  }

  ready(function () {
    let root = document.querySelector(SELECTORS.root);

    if (!root) {
      return;
    }

    initPage(root);
  });
})();
